"use strict";

var _interopRequireDefault = require("/www/wwwroot/node/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMoney = addMoney;
exports.changePassword = changePassword;
exports.createAlipay = createAlipay;
exports.createShopType = createShopType;
exports.createUser = createUser;
exports.deleteUser = deleteUser;
exports.getAlipayList = getAlipayList;
exports.getConfigList = getConfigList;
exports.getInfo = getInfo;
exports.getShopTypeList = getShopTypeList;
exports.getUser = getUser;
exports.getUserList = getUserList;
exports.login = login;
exports.logout = logout;
exports.updateAlipatStatus = updateAlipatStatus;
exports.updateAlipay = updateAlipay;
exports.updateConfig = updateConfig;
exports.updateUser = updateUser;
var _request = _interopRequireDefault(require("@/utils/request"));
function login(data) {
  return (0, _request.default)({
    url: '/token1/',
    method: 'post',
    data: data
  });
}
function logout() {
  return (0, _request.default)({
    url: '/token/black/',
    method: 'get'
  });
}
function getInfo() {
  // console.log('getInfo')
  return (0, _request.default)({
    url: '/system/user/info/',
    method: 'get'
  });
}
function updateConfig(id, data) {
  return (0, _request.default)({
    url: "/system/user/updateConfig/",
    method: 'put',
    data: data
  });
}
function getConfigList(query) {
  return (0, _request.default)({
    url: '/system/user/getConfigList/',
    method: 'get',
    params: query
  });
}
function getShopTypeList(query) {
  return (0, _request.default)({
    url: '/system/shopConfig/getShopTypeList/',
    method: 'get',
    params: query
  });
}
function createShopType(data) {
  return (0, _request.default)({
    url: '/system/shopConfig/createShopType/',
    method: 'post',
    data: data
  });
}
// export function updateAlipay(id, data) {
//   return request({
//     url: `/system/alipayconfig/${id}/`,
//     method: 'put',
//     data
//   })
// }

function getAlipayList(query) {
  return (0, _request.default)({
    url: '/system/alipayconfig/',
    method: 'get',
    params: query
  });
}
function createAlipay(data) {
  return (0, _request.default)({
    url: '/system/alipayconfig/',
    method: 'post',
    data: data
  });
}
function updateAlipay(id, data) {
  return (0, _request.default)({
    url: "/system/alipayconfig/".concat(id, "/"),
    method: 'put',
    data: data
  });
}
function updateAlipatStatus(id, data) {
  return (0, _request.default)({
    url: "/system/alipayconfig/alipay_status_update/",
    method: 'put',
    data: data
  });
}
function getUserList(query) {
  return (0, _request.default)({
    url: '/system/user/',
    method: 'get',
    params: query
  });
}
function getUser(id) {
  return (0, _request.default)({
    url: "/system/user/".concat(id, "/"),
    method: 'get'
  });
}
function createUser(data) {
  return (0, _request.default)({
    url: '/system/user/',
    method: 'post',
    data: data
  });
}
function updateUser(id, data) {
  return (0, _request.default)({
    url: "/system/user/".concat(id, "/"),
    method: 'put',
    data: data
  });
}
function deleteUser(id, data) {
  return (0, _request.default)({
    url: "/system/user/".concat(id, "/"),
    method: 'delete',
    data: data
  });
}
function changePassword(data) {
  return (0, _request.default)({
    url: '/system/user/password/',
    method: 'put',
    data: data
  });
}
function addMoney(data) {
  return (0, _request.default)({
    url: '/system/user/money/',
    method: 'put',
    data: data
  });
}